import {FlowBuilderSettings} from "@/config/flowBuilderSettings";

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

const BASE_URL_MIDDLEWARE = "https://backend-{ENV}.synthflow.dev/v2";

interface ApiOptions extends RequestInit {
  headers?: HeadersInit;
}

export async function apiClient(endpoint: string, options: ApiOptions = {}) {
  const JWT_TOKEN = FlowBuilderSettings.jwt;
  const ENV = FlowBuilderSettings.backendENV || "prod";

  const defaultHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${JWT_TOKEN}`,
  };

  try {
    const response = await fetch(
      `${BASE_URL_MIDDLEWARE.replace("{ENV}", ENV)}${endpoint}`,
      {
        ...options,
        headers: {...defaultHeaders, ...options.headers},
      },
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new ApiError(
        errorData?.message || `Error ${response.status}`,
        response.status,
      );
    }

    return response.json();
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}
